/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespSidebarBlurbs_viewer = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
